// extracted by mini-css-extract-plugin
export var active = "_1q-b";
export var activeIndicator = "_1q-6";
export var animate = "_1q-a";
export var disabled = "_1q-c";
export var flat = "_1q-1";
export var fullWidth = "_1q-3";
export var lg = "_1q-9";
export var md = "_1q-8";
export var redoButtonTabGroup = "_1q-0";
export var sm = "_1q-7";
export var tabButton = "_1q-4";
export var tabButtonsContainer = "_1q-2";
export var xs = "_1q-5";